import i18next from 'i18next'
import { isEmpty } from '../../form'
import { formatTime } from '../../utils/openForWork.utils'
import { format } from 'date-fns'
import { toMinutes } from '../validate'

// Field validators
export const registerValidate = (values) => {
  const errors = {}
  const requiredFields = [
    'company_name',
    'y_tunnus',
    'contact_name',
    'email',
    'password',
    'passwordConfirmation',
    'agree_to_terms'
  ]

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('employer.validation.kenta') // 'Kenttä on pakollinen'
    }
  })

  if (!values['password']) {
    errors.password = i18next.t('employer.validation.sala') //'Salasanakenttä on pakollinen'
  }

  if (
    values['password'] &&
    !/^(?=^.{8,}$)(?=.*\d)(?=.*[äöåa-z])(?=.*[ÄÖÅA-Z])(?!.*\s)[0-9äöåa-zÄÖÅA-Z!@#$€£%^&*()]*$/.test(
      values['password']
    )
  ) {
    errors.password = i18next.t('employer.validation.virhe')
    //'Virheellinen salasana, Salasanan tulee sisältää vähintään: 8 merkkiä, numeroita, pieniä ja isoja kirjaimia!'
  }

  if (values['password'] !== values['passwordConfirmation']) {
    errors.passwordConfirmation = i18next.t('employer.validation.anta') //'Antamasi salasanat eivät täsmää'
  }

  if (!values['passwordConfirmation']) {
    errors.passwordConfirmation = i18next.t('employer.validation.vahvis') //'Salasanan vahvistus on pakollinen'
  }

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = i18next.t('employer.validation.sposti') //'Antamasi sähköpostiosoite  on virheellinen'
  }

  //console.log('Inside registerValidate:: ', errors)
  return { values, errors }
}

export const loginValidate = (values) => {
  const errors = {}
  const requiredFields = ['email', 'password']

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('employer.validation.kenta') // 'Kenttä on pakollinen'
    }
  })
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = i18next.t('employer.validation.sposti') //'Antamasi sähköpostiosoite  on virheellinen'
  }
  return { values, errors }
}

export const passwordValidate = (values) => {
  const errors = {}
  const requiredFields = ['current_pw', 'new_pw', 'check_pw']

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('employer.validation.pako') // 'Kenttä on pakollinen'
    }
  })

  if (
    values.new_pw &&
    !/^(?=^.{8,}$)(?=.*\d)(?=.*[äöåa-z])(?=.*[ÄÖÅA-Z])(?!.*\s)[0-9äöåa-zÄÖÅA-Z!@#$€£%^&*()]*$/.test(
      values['new_pw']
    )
  ) {
    errors.new_pw = i18next.t('employer.validation.virhe2') // 'Virheellinen salasana, noudata ohjeita!'
  }

  if (values['new_pw'] !== values['check_pw']) {
    errors.check_pw = i18next.t('employer.validation.anta') //'Antamasi salasanat eivät täsmää'
  }

  return { values, errors }
}

export const resetPasswordValidate = (values) => {
  const errors = {}
  const requiredFields = ['email']

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('employer.validation.pako') //'Kenttä on pakollinen'
    }
  })

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = i18next.t('employer.validation.sposti') //'Antamasi sähköpostiosoite  on virheellinen'
  }

  return { values, errors }
}

export const companyProfileValidate = (values) => {
  const errors = {}
  let requiredFields = [
    'contactName',
    'address',
    'billing_method',
    'phoneNumber',
    'city',
    'field_work',
    'zipCode',
    'country'
  ]
  if (values['billing_method'] === 'Verkkolasku') {
    requiredFields = [
      'contactName',
      'address',
      'billing_method',
      'phoneNumber',
      'city',
      'field_work',
      'zipCode',
      'country',
      'e_invoice_address',
      'e_invoice_operator'
    ]
  }

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('employer.validation.pako') //'Kenttä on pakollinen'
    }
  })

  return { values, errors }
}

export const assignmentValidate = (values) => {
  const errors = {}
  let requiredFields = [
    'jobTitle',
    // 'industryType',
    'location',
    'assignmentType',
    'lastDate',
    'manualNotice',
    'salaryModel',
    'assignmentBegin'
    // 'offer_to_industry'
  ]
  if (
    (values['assignmentType'] !== '' &&
      values['salaryModel'] === 'hourly_rate') ||
    (values['assignmentType'] === 'until_completion' &&
      values['salaryModel'] === 'commission')
  ) {
    requiredFields.push('hourlyRate')
  }
  if (
    (values['assignmentType'] !== '' &&
      values['salaryModel'] === 'hourly_rate') ||
    (values['assignmentType'] !== '' && values['salaryModel'] === 'commission')
  ) {
    requiredFields.push('weeklyHours')
  }

  if (
    (values['assignmentType'] === 'until_further_notice' &&
      values['salaryModel'] === 'contract_price') ||
    (values['assignmentType'] === 'temporary' &&
      values['salaryModel'] === 'contract_price') ||
    (values['assignmentType'] === 'temporary' &&
      values['salaryModel'] === 'commission')
  ) {
    requiredFields.push('amount_e')
  }

  if (
    (values['assignmentType'] === 'until_further_notice' &&
      values['salaryModel'] === 'unit_price') ||
    (values['assignmentType'] === 'temporary' &&
      values['salaryModel'] === 'unit_price')
  ) {
    requiredFields.push('amount_e')
  }

  if (
    values['assignmentType'] === 'temporary' &&
    values['salaryModel'] !== ''
  ) {
    requiredFields.push('assignmentEnds')
    if (
      formatDate(values['assignmentEnds']) <
      formatDate(values['assignmentBegin'])
    ) {
      errors.assignmentEnds = i18next.t('employer.validation.endDate') // End date can't be earlier than begin date
    }
  }

  if (
    values['assignmentType'] === 'until_completion' &&
    values['salaryModel'] === 'contract_price'
  ) {
    requiredFields.push('contractSalary')
  }

  if (
    values['assignmentType'] === 'until_completion' &&
    values['salaryModel'] === 'unit_price'
  ) {
    requiredFields.push('unitPrice')
  }

  if (
    values['assignmentType'] === 'until_further_notice' &&
    values['salaryModel'] === 'commission'
  ) {
    requiredFields.push('amount_e')
  }

  if (
    values['offer_to_e_email'].length === 0 ||
    (values['offer_to_e_email'].length === 1 &&
      (values['offer_to_e_email'][0] === '' ||
        values['offer_to_e_email'][0] === undefined))
  ) {
    requiredFields.push('offer_to_industry')
  }

  // if (
  //   (values['offer_to_industry'].length === 1 &&
  //     (values['offer_to_industry'][0] === '' ||
  //       values['offer_to_industry'][0] === undefined)) ||
  //   values['offer_to_industry'].length === 0
  // ) {
  //   errors.offer_to_industry = i18next.t('employer.validation.pako') //'Kenttä on pakollinen'
  // }

  if (
    values['manualNotice'] !== '' &&
    (values['manualNotice'] < 0 || values['manualNotice'] > 185)
  ) {
    errors.manualNotice = 'Must be between (0-185) days'
  }

  if (
    values['weeklyHours'] !== '' &&
    (values['weeklyHours'] < 0 || values['weeklyHours'] > 70)
  ) {
    errors.weeklyHours = 'Must be between (0-70) hours'
  }

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('employer.validation.pako') //'Kenttä on pakollinen'
    }
  })

  return { values, errors }
}

// Contract form at light entrepreneurs tab
export const contractFormValidateLE = (values) => {
  const errors = {}
  let requiredFields = [
    'amount',
    'assignment_begins',
    // 'assignment_ends',
    'payment_terms',
    'assignment_type',
    'salary_model'
    // 'content_assignment'
  ]

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('employer.validation.pako') //'Kenttä on pakollinen'
    }
  })

  if (
    values['assignment_type'] === 'temporary' &&
    values['assignment_ends'] < values['assignment_begins']
  ) {
    errors.assignment_ends = i18next.t('employer.validation.endDate') // End date can't be earlier than begin date
  }

  return { values, errors }
}

// Work shift form

export const workShiftFormValidate = (values) => {
  const errors = {}
  const shiftsByDate = new Map() // Map<date, Array<{ start: number, end: number, index: number }>>

  let requiredFields = [
    'offer_to',
    'location',
    'task_description',
    'additional_infor'
  ]
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = i18next.t('employer.validation.pako') //'Kenttä on pakollinen'
    }
  })

  const approval_deadline = values.approval_deadline

  const rowErrors = []
  values.dateRows.forEach((row, index) => {
    const error = {}
    const dateKey = format(new Date(row.shiftstartdate), 'yyyy-MM-dd')

    const start = toMinutes(row.shiftstarttime)
    const end = toMinutes(row.shiftendtime)

    if (formatDate(row.shiftstartdate) < formatDate(approval_deadline)) {
      error.shiftstartdate = i18next.t('employer.workshifts.valid2') // The date must be no earlier than the acceptance date
    }

    // Check if start time is before end time
    const shiftstarttime = formatTime(row.shiftstarttime)
    const shiftendtime = formatTime(row.shiftendtime)
    if (shiftstarttime && shiftendtime && shiftstarttime >= shiftendtime) {
      error.shiftstarttime = i18next.t('employer.workshifts.valid1') // Start time must be earlier than end time
    }
    if (shiftstarttime && shiftendtime && shiftendtime <= shiftstarttime) {
      error.shiftendtime = i18next.t('employer.workshifts.valid3') // End time must be later than start time
    }

    // Check overlap with previous shifts on the same date
    if (!shiftsByDate.has(dateKey)) {
      shiftsByDate.set(dateKey, [])
    }

    const existingShifts = shiftsByDate.get(dateKey)
    for (const shift of existingShifts) {
      const overlaps = start < shift.end && end > shift.start
      if (overlaps) {
        error.shiftstarttime = i18next.t('employer.workshifts.valid4')
        error.shiftendtime = i18next.t('employer.workshifts.valid4')
        break
      }
    }

    // Add current shift to tracking list
    existingShifts.push({ start, end, index })

    if (!isEmpty(error)) {
      rowErrors[index] = error
    }
  })

  if (!isEmpty(rowErrors)) {
    errors.dateRows = rowErrors
  }

  return { values, errors }
}

export const formatDate = (item) => {
  const date = new Date(item).setHours(0, 0, 0, 0)
  return new Date(date)
}
